module.exports = __webpack_public_path__ + "img/bomba_zprop.927e7716.jpg";